import { render, staticRenderFns } from "./SectionOrderFields.vue?vue&type=template&id=4af23ec9&"
import script from "./SectionOrderFields.vue?vue&type=script&lang=js&"
export * from "./SectionOrderFields.vue?vue&type=script&lang=js&"
import style0 from "./SectionOrderFields.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./SectionOrderFields.vue?vue&type=style&index=1&lang=scss&module=w&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)
this["w"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports